import React from 'react';
import { InterPoint } from '@saviynt/common';
import { Box, Typography } from '@saviynt/design-system';

import { CF_NEU_BLD, CF_NEU_STL } from '../../constants';

interface SodColumnChipProps {
  name: string;
  value: string;
  isPrefixInterpoint: boolean;
}

/**
 * SodColumnChip Component
 *
 * Column chip component for displaying name-value pairs in extended column views
 * with optional InterPoint separator for consistent data presentation.
 *
 * @component
 * @returns {React.ReactElement} Column chip with formatted name-value display
 *
 * @example
 * <SodColumnChip
 *   name="Status"
 *   value="Active"
 *   isPrefixInterpoint={true}
 * />
 */
function SodColumnChip({
  name,
  value,
  isPrefixInterpoint = true,
}: SodColumnChipProps) {
  const nameText = `${name}:`;

  return (
    <Box className='Sod-ViolationsTabList-listRowAccountStat'>
      <Typography kind='body2' color={CF_NEU_STL}>
        {nameText}
      </Typography>
      <Typography
        kind='body2'
        desktop='body2-d'
        mobile='body2-d'
        className={CF_NEU_BLD}
        lineLimit={1}>
        {value === '' ||
        value === 'null' ||
        value === 'undefined' ||
        value.trim() === ''
          ? '-'
          : value}
      </Typography>
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </Box>
  );
}

export default SodColumnChip;
